import { IIpAccessRulesState, DataIpAccessRules } from "../@types";
import { ipAccessRulesActions } from "../action-types";

type ipAccessRulesType =
  | { type: typeof ipAccessRulesActions.IP_ACCESS_RULES_MODAL_STATE }
  | {
      type: typeof ipAccessRulesActions.GET_IP_ACCESS_RULES_FOR_UPDATE;
      payload: DataIpAccessRules;
    }
  | {
      type: typeof ipAccessRulesActions.IS_IP_ACCESS_RULES_FOR_UPDATE;
      payload: boolean;
    }
  | {
      type: typeof ipAccessRulesActions.SWITCH_IP_ACCESS_RULES_REFRESH_TABLE;
      payload: boolean;
    };

const INITIAL_STATE: IIpAccessRulesState = {
  ipAccessRulesForUpdate: undefined,
  isUpdateIpAccessRules: false,
  ipAccessRulesModalIsOpen: false,
  refreshTableIpAccessRules: false,
};

export default function ipAccessRulesReducer(
  state: IIpAccessRulesState = INITIAL_STATE,
  action: ipAccessRulesType
): IIpAccessRulesState {
  switch (action.type) {
    case ipAccessRulesActions.IP_ACCESS_RULES_MODAL_STATE:
      return {
        ...state,
        ipAccessRulesModalIsOpen: !state.ipAccessRulesModalIsOpen,
      };
    case ipAccessRulesActions.GET_IP_ACCESS_RULES_FOR_UPDATE:
      return {
        ...state,
        ipAccessRulesForUpdate: action.payload,
      };
    case ipAccessRulesActions.IS_IP_ACCESS_RULES_FOR_UPDATE:
      return {
        ...state,
        isUpdateIpAccessRules: action.payload,
      };
    case ipAccessRulesActions.SWITCH_IP_ACCESS_RULES_REFRESH_TABLE:
      return {
        ...state,
        refreshTableIpAccessRules: action.payload,
      };
    default:
      return state;
  }
}
